import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  margin-top: 16px;
  margin-bottom: 12px;
`;

const Title = styled.div`
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
  padding-bottom: 4px;
`;

const Table = styled.table`
  width: 100%;
  font-size: 11px;
  border-collapse: collapse;
`;

const HeaderCell = styled.th`
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  padding: 3px 4px;
  text-align: ${({ $align = 'left' }) => $align};
  font-weight: 700;
  background: transparent;
`;

const Cell = styled.td`
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  padding: 3px 4px;
  text-align: ${({ $align = 'left' }) => $align};
  white-space: ${({ $nowrap }) => ($nowrap ? 'nowrap' : 'normal')};
  vertical-align: ${({ $valign = 'middle' }) => $valign};
`;

export default function EquivalenciasPrintTable({
  equivalenciasData,
  getOriginalByRepId,
  title = 'Equivalencias de Repuestos',
}) {
  if (!equivalenciasData || Object.keys(equivalenciasData).length === 0) {
    return null;
  }

  const tieneEquivalencias = Object.values(equivalenciasData).some((eq) => Array.isArray(eq) && eq.length > 0);
  if (!tieneEquivalencias) {
    return null;
  }

  return (
    <Wrap>
      <Title>{title}</Title>
      <Table>
        <thead>
          <tr>
            <HeaderCell>Repuesto Original</HeaderCell>
            <HeaderCell>Equivalente</HeaderCell>
            <HeaderCell $align="center">Stock Obra</HeaderCell>
            <HeaderCell $align="center">Usado</HeaderCell>
          </tr>
        </thead>
        <tbody>
          {Object.entries(equivalenciasData).map(([repId, equivalentes]) => {
            if (!Array.isArray(equivalentes) || equivalentes.length === 0) {
              return null;
            }

            const original = getOriginalByRepId ? getOriginalByRepId(repId) : null;
            const originalCodigo = original?.codigo || '-';
            const originalDescripcion = original?.descripcion || '-';

            return (
              <React.Fragment key={repId}>
                {equivalentes.map((eq, idx) => (
                  <tr key={`${repId}-${eq.id || idx}`}>
                    {idx === 0 ? (
                      <Cell rowSpan={equivalentes.length} $nowrap $valign="top">
                        <strong>{originalCodigo}</strong>
                        {' - '}
                        <span>{originalDescripcion}</span>
                      </Cell>
                    ) : null}
                    <Cell $nowrap>
                      <strong>{eq.codigo || '-'}</strong>
                      {' - '}
                      <span>{eq.descripcion || '-'}</span>
                    </Cell>
                    <Cell $align="center">{eq.stock_en_obra ?? '-'}</Cell>
                    <Cell $align="center">&nbsp;</Cell>
                  </tr>
                ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </Table>
    </Wrap>
  );
}
